function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { isType, ModalAction, VideoModalAction, RatingAction, DriveModalAction, IFieldHubModalAction, IDisclaimerModalAction, MediaModalAction, InstructionsModalAction, EntityReviewCommentModalAction, EntityReviewMarkAsHelpfulModalAction } from './../actions/actions';
import { initialModalState, copyState } from './../../State';
import { Constants } from '../utils/constants';
export default function modalReducer(state = initialModalState, action) {
    const newState = copyState(state);
    if (isType(action, ModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.entityId = action.payload.entityId ? action.payload.entityId : '';
        newState.modalId = action.payload.modalId ? action.payload.modalId : Constants.ModalType.NoModalShow;
        newState.options = action.payload.options;
        newState.entityType = action.payload.entityType;
        newState.onModalDismiss = action.payload.onModalDismiss;
        newState.disableDismissModal = action.payload.disableDismissModal;
        newState.isOpenedFromPDP = action.payload.isOpenedFromPDP;
        newState.payload = null;
    } else if (isType(action, VideoModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.Video;
        const videoPayload = {
            videoLink: action.payload.videoUrl,
            thumbnailURL: action.payload.videoThumbnail,
            videoName: action.payload.videoName
        };
        newState.payload = videoPayload;
    } else if (isType(action, MediaModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.MediaModal;
        newState.payload = action.payload.payload;
    } else if (isType(action, DriveModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.Drive;
        const drivePayload = {
            urlLink: action.payload.driveUrl
        };
        newState.payload = drivePayload;
    } else if (isType(action, IFieldHubModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.Iframe;
        const iframePayload = {
            reportName: action.payload.reportName
        };
        newState.payload = iframePayload;
    } else if (isType(action, IDisclaimerModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.Disclaimer;
        const payload = {
            title: action.payload.title,
            description: action.payload.description
        };
        newState.payload = payload;
    } else if (isType(action, RatingAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.Rating;
        const reviewPayload = {
            showModal: true,
            app: action.payload.app,
            accessKey: action.payload.accessKey,
            ctaType: action.payload.ctaType,
            callback: action.payload.callback
        };
        newState.payload = reviewPayload;
    } else if (isType(action, EntityReviewCommentModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.ReviewComment;
        newState.payload = _object_spread({}, action.payload);
    } else if (isType(action, EntityReviewMarkAsHelpfulModalAction)) {
        newState.showModal = action.payload.showModal;
        newState.modalId = Constants.ModalType.ReviewMarkAsHelpful;
        newState.payload = _object_spread({}, action.payload);
    } else if (isType(action, InstructionsModalAction)) {
        newState.modalId = Constants.ModalType.Instructions;
        newState.showModal = action.payload.showModal;
        const instructionsPayload = {
            isFromDownload: action.payload.isFromDownload
        };
        newState.payload = instructionsPayload;
    } else {
        return state;
    }
    return newState;
}
